import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Products.css";
import { Link } from "react-router-dom";
import contact from "../Images/Group-of-customer-service-representatives.jpg";

import image1 from "../Images/Mr.Olive/jalapeno/فلفل شيري سليم.jpg";
import image2 from "../Images/Mr.Olive/jalapeno/فلفل شيري مخلي.jpg";
import image3 from "../Images/Mr.Olive/jalapeno/فلفل هاليبينو أحمر سليم.jpg";
import image4 from "../Images/Mr.Olive/jalapeno/فلفل هاليبينو أحمر شرائح.jpg";
import image5 from "../Images/Mr.Olive/jalapeno/فلفل لمباردي.jpg";
import image6 from "../Images/Mr.Olive/jalapeno/فلفل مكسيكي.jpg";
import image7 from "../Images/Mr.Olive/jalapeno/فلفل هاليبينو أخضر سليم 1.jpg";
import image8 from "../Images/Mr.Olive/jalapeno/هاليبينو اخضر.jpg";
import image9 from "../Images/Mr.Olive/jalapeno/هريسة.jpg";
import image10 from "../Images/Mr.Olive/mix/فلفل بنانا شرائح مخلي.jpg";
import image24 from "../Images/Mr.Olive/packages/_KH13102-Recovered.jpg";
import image25 from "../Images/Mr.Olive/jalapeno/edited 3.jpg";
import image26 from "../Images/Mr.Olive/jalapeno/edited 4.jpg";

export default function ProductCat3() {
  const [currID, setCurrID] = useState("");
  const [loading, setLoading] = useState(false);
  const [productName, setProductName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  async function sendQuote(e) {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        `https://mrolive-back-end-2c3o.onrender.com/api/v1/quote`,
        {
          name: name,
          email: email,
          productName: productName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.msg);
        setName("");
        setEmail("");
        document.getElementById("name").value = "";
        document.getElementById("email").value = "";
      })
      .catch((e) => {
        toast.error(e?.data?.msg);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  let imgList = Array.from(document.getElementsByClassName("imgItem"));
  let lightContainer = document.querySelector(".lightContainer");
  let lightBox = document.querySelector(".lightBox");
  let currentIndex = 0;
  let tmp = [
    {
      id: "1",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>وصف السلعة</th>
              <th>الطول</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>فلفل شيري احمر سليم</th>
              <td> 25-50 مم </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "2",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>وصف السلعة</th>
              <th>الطول</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th> فلفل شيري احمر مخلي</th>
              <td> 25-50 مم </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "3",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>وصف السلعة</th>
              <th>الطول</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th> فلفل هالبينو احمر سليم</th>
              <td> 4-8 سم </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "4",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>وصف السلعة</th>
              <th>سمك الشرائح </th>
              <th>قطر الشرائح</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>فلفل هالبينو أحمر شرائح </th>
              <td> 1 سم</td>
              <td>1.5 سم : 3.5 سم </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    { id: "5", text: `` },
    {
      id: "6",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>وصف السلعة</th>
              <th colSpan="2">الطول</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowSpan="2"> فلفل مكسيكي </th>
              <td> ميديام </td>
              <td> 3-6 سم </td>
            </tr>
            <tr>
              <td> لارج </td>
              <td> 6-10 سم </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "7",
      text: ` `,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>وصف السلعة</th>
              <th>الطول</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th> فلفل هالبينو اخضر سليم</th>
              <td> 4-8 سم </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "8",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>وصف السلعة</th>
              <th>سمك الشرائح </th>
              <th>قطر الشرائح</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th> فلفل هالبينو اخضر شرائح</th>
              <td> 0.5 سم </td>
              <td> 1.5 سم : 3 سم </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    { id: "9", text: `` },
    {
      id: "10",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>وصف السلعة</th>
              <th>سمك الشرائح </th>
              <th>قطر الشرائح</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th> فلفل بنانا شرائح</th>
              <td> 6 مم </td>
              <td>3 سم : 6 سم </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    { id: "11", text: `` },
  ];
  function showImage(x) {
    document
      .querySelector(".lightContainer2")
      .classList.replace("d-none", "d-flex");
    // console.log("ayhagaaasa")
    document.querySelector(".very").style.backgroundImage = `url(${x.src})`;
    document.querySelector(".productName").innerHTML = x.name;

    currentIndex = x.id;
    setCurrID(currentIndex);

    // console.log(currentIndex)
  }

  function closeSlide() {
    document
      .querySelector(".lightContainer2")
      .classList.replace("d-flex", "d-none");
  }
  function showForm() {
    document
      .querySelector(".showForm")
      .classList.replace("d-none", "d-inline-block");
  }
  return (
    <>
      <ToastContainer />

      <div className="products "></div>
      <div className="container p-4">
        <div className="row p-3">
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="1"
                src={image1}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل شيري سليم");
                }}
                alt="image not found"
                className="photo"
                name="فلفل شيري سليم"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              فلفل شيري سليم
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="2"
                src={image2}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل شيري مخلي");
                }}
                alt="image not found"
                className="photo"
                name="فلفل شيري مخلي"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              فلفل شيري مخلي
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="3"
                src={image3}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل هالبينو احمر سليم");
                }}
                alt="image not found"
                className="photo"
                name="فلفل هالبينو احمر سليم"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              فلفل هالبينو احمر سليم
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="4"
                src={image4}
                onClick={(e) => showImage(e.target)}
                alt="image not found"
                className="photo"
                name="فلفل هالبينو احمر شرائح"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              فلفل هالبينو احمر شرائح
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="5"
                src={image5}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل لمباردي");
                }}
                alt="image not found"
                className="photo"
                name="فلفل لمباردي"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              فلفل لمباردي
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="6"
                src={image6}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل مكسيكي");
                }}
                alt="image not found"
                className="photo"
                name="فلفل مكسيكي"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>فلفل مكسيكي</p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="7"
                src={image7}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل هالبينو اخضر سليم");
                }}
                alt="image not found"
                className="photo"
                name="فلفل هالبينو اخضر سليم"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              فلفل هالبينو اخضر سليم
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="8"
                src={image8}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل هالبينو اخضر شرائح");
                }}
                alt="image not found"
                className="photo"
                name="فلفل هالبينو اخضر شرائح"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              فلفل هالبينو اخضر شرائح
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="9"
                src={image9}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل احمر هريسه");
                }}
                alt="image not found"
                className="photo"
                name="فلفل احمر هريسه"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              فلفل احمر هريسه
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="10"
                src={image10}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل بنانا مخلي شرائح");
                }}
                alt="image not found"
                className="photo"
                name="فلفل بنانا مخلي شرائح"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              فلفل بنانا مخلي شرائح
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className=" imgItem">
              <img
                id="11"
                src={image24}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("");
                }}
                alt="image not found"
                className="photo"
                name=""
              />{" "}
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}></p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className=" imgItem">
              <img
                id="11"
                src={image25}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل احمر سليم");
                }}
                alt="image not found"
                className="photo"
                name="فلفل احمر سليم"
              />{" "}
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}></p>
          </div>{" "}
          <div className="col-md-4 photoContainer2">
            <div className=" imgItem">
              <img
                id="11"
                src={image26}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("فلفل احمر شرائح");
                }}
                alt="image not found"
                className="photo"
                name="فلفل احمر شرائح"
              />{" "}
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}></p>
          </div>
        </div>
      </div>
      <div className="lightContainer2 d-none  align-items-center">
        <div className="lightBox2  ">
          <div className="container">
            <div className="row d-flex justify-content-center ">
              <div className="ayhaga" style={{ marginTop: "30px" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img className=" very" alt="" style={{ padding: "0" }} />
                </div>
                <h4
                  className="productName"
                  style={{
                    color: "#4e732c",
                    display: "flex",
                    justifyContent: "center",
                  }}
                ></h4>
                {tmp.map((each) => {
                  if (each.id === currID) {
                    return (
                      <div>
                        <p style={{ color: "white" }} dir="rtl" lang="ar">
                          {" "}
                          اصبحت مصر من الدول الرائدة في انتاج وتصنيع الفلفل
                          بجميع انواعه وقامت شركتنا بادخال الاساليب الحديثة في
                          الزراعة والتصنيع والتعبئة وايضا الاسعار التنافسية
                          العالمية.{" "}
                        </p>
                        <div>{each.table}</div>
                      </div>
                    );
                  }
                })}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px",
                  }}
                >
                  <button
                    className="btn get bgDark"
                    style={{ marginBottom: "5px" }}
                    onClick={showForm}
                  >
                    احصل علي عرض الاسعار
                  </button>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <form onSubmit={sendQuote}>
                    <div className="showForm d-none ">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="ادخل اسمك"
                        style={{ marginBottom: "5px" }}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      />
                      <input
                        type="email"
                        className="form-control"
                        // id="exampleFormControlInput2"
                        id="email"
                        placeholder="ادخل البريد الالكتروني"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "10px",
                        }}
                      >
                        <button
                          className="btn get"
                          style={{ marginTop: "5px" }}
                          type="submit"
                        >
                          {loading ? (
                            <i className="fa-solid fa-spinner fa-spin"></i>
                          ) : (
                            "ارسال"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <i
            style={{
              color: "black",
              backgroundColor: "white",
              padding: "10px",
              borderRadius: "10px",
            }}
            id="close"
            className="fa-solid fa-xmark"
            onClick={closeSlide}
          ></i>
        </div>
      </div>
    </>
  );
}
